import './parts/utilities.js';
import Splide from '@splidejs/splide';
import { MobileMenu } from './parts/mmenu-light.js';
import { HeaderMenu } from './parts/navigation.js';
import './parts/cookie.js';
import './parts/animations.js';

document.addEventListener("DOMContentLoaded", () => {
	
	// mmenu
	MobileMenu();

	// controls hover over main menu/global finder/search so they all work together
	const header = document.getElementById('masthead');
	if(header){
		new HeaderMenu( header );
	}

	let featuredPosts = document.querySelector('.featured-posts .splide');

	if( featuredPosts ){
		new Splide( featuredPosts, {
			type   : 'loop',
			perPage: 1,
			pagination: false,
			arrows: true,
			padding: { right: "15%" },
			gap: "1rem",
			breakpoints:{
				480: {
					padding: { right: 0 }
				}
			}
		} ).mount();
	}

});